export const SET_GOOGLE_ANALYTIC_TRACKING = "SET_GOOGLE_ANALYTIC_TRACKING";
export const MILKYWAY_SCREEN_REACHED_CATEGORY =
  "MILKYWAY_SCREEN_REACHED_CATEGORY";
export const LAST_STORY_SLIDE_REACHED = "LAST_STORY_SLIDE";
export const VIRTUAL_FARM_TOUR_STARTED = "VIRTUAL_FARM_TOUR_STARTED";
export const VIRTUAL_FARM_TOUR_WATCHED = "VIRTUAL_FARM_TOUR_WATCHED";
export const BACK_TO_FARM_CLICKED = "BACK_TO_FARM_CLICKED";
export const BATCH_FARM_VISITOR = "BATCH_FARM_VISITOR";
export const BATCHLESS_FARM_VISITOR = "BATCHLESS_FARM_VISITOR";
